import { LoggerFactory } from 'nordic/logger';
import { misc } from '@credits-utils/constants';

const TRACKING_LOGGER = 'tracking-utils';
const TRACKING_CONTEXT = 'utils/tracking';
const { LOGGER_TRANSACTION, LOGGER_EXECUTION } = misc;

const logger = LoggerFactory(TRACKING_LOGGER);

const sendMelidataTrack = ({ type, path, event_data: eventData = {} }) => {
  // Send Melidata track with provided type, path and event data
  melidata('cleanAndSend', type, { path, data: eventData });
};
const trackAction = (action) => {
  if (typeof action.melidata === 'object' && action.melidata !== null) {
    try {
      sendMelidataTrack(action.melidata);
    } catch (error) {
      logger.error(`${LOGGER_TRANSACTION.FAILED} - fail to track Melidata`, {
        context: TRACKING_CONTEXT,
        execution: LOGGER_EXECUTION.FAILED,
        melidata: action.melidata,
      }, error);
    }
  }
};

export {
  trackAction,
  sendMelidataTrack,
};
